<template>
	<div class="modal is-active">
		<div class="modal-background"></div>
		<div class="modal-card">
			<header class="modal-card-head">
				<p class="modal-card-title">
					VEJA COMO É FÁCIL UTILIZAR
				</p>
				<button class="delete" aria-label="close" @click="goBack"></button>
			</header>
            <section class="modal-card-body">
                <img src="../../public/images/tutorial20200129.gif">
            </section>
		</div>
	</div>
</template>


<style scoped>
img { 
    max-width: 384px;
    margin: 0 auto;
}
.modal-card-title { flex-shrink: 1; }
</style>

<script>

export default {
	data() {
		return {
		}
	},
	methods:{
		goBack(){
			this.$router.push({name:'home'});
		},
	},
	mounted() {
	},
};
</script>

